export default {"src":"/_next/static/media/getsafe.605b80f8.svg","height":31,"width":171,"blurWidth":0,"blurHeight":0};